import { Component, Inject, OnInit } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet } from "@angular/material/bottom-sheet";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Subject, takeUntil } from "rxjs";
import { GameDatasService } from "src/app/pages/games/services/game-data.service";
@Component({
  selector: "app-surprise-gift-slide-up",
  standalone: true,
  imports: [IonicModule],
  templateUrl: "./surprise-gift-slide-up.component.html",
  styleUrl: "./surprise-gift-slide-up.component.scss",
})
export class SurpriseGiftSlideUpComponent implements OnInit {
  giftCardData: Data;
  destination: string;
  selectedLanguage: string;
  currencyValueHtml: any;
  isCredit: boolean;
  isGameIcon: boolean;
  private unsubscribe$ = new Subject<void>();
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: Data,
    private gameDatasService : GameDatasService,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private bottomSheet: MatBottomSheet
  ) {
    // Set data to giftCardData
    this.giftCardData = data;
    this.selectedLanguage = "en";
  }

  ngOnInit(): void {
    this.getTranslation();
    if(this.giftCardData?.content?.[this.selectedLanguage]?.image_text){
      this.currencyConversion(this.giftCardData?.content[this.selectedLanguage].image_text);
    }
  }

  private ensureValidLanguage(): void {
    if (!this.giftCardData?.content) return;
    const defaultLanguage = "en";
    if (!this.giftCardData?.content?.[this.selectedLanguage]) {
      if (this.giftCardData?.content?.[defaultLanguage]) {
        this.selectedLanguage = defaultLanguage;
      } else {
        const availableLanguages = Object?.keys(this.giftCardData?.content);
        if (availableLanguages?.length > 0) {
          this.selectedLanguage = availableLanguages?.[0];
        }
      }
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  // Get translation from service
  getTranslation() {
    this.authService?.selectedlanguage$?.pipe(takeUntil(this.unsubscribe$)).subscribe((l) => {
      if (l) {
        this.selectedLanguage = l;
        this.translate.use(l ? l : "en");
        this.ensureValidLanguage();
      }
    });
  }

  // This function is used to redirect user
  redirectTo(destination: string) {
    this.router.navigateByUrl(destination);
    this.bottomSheet.dismiss();
  }

  // This function is used to convert currency value in html
  async currencyConversion(value) {
    // Check if the value contains any of the specified strings ('Marbles', 'Zen', or 'Word')
    this.isGameIcon = value.includes("Marbles") || value.includes("Zen") || value.includes("Word");
    if (value.indexOf("[currency_beautify:") === -1) this.currencyValueHtml = value;
    const startIndex = value.indexOf("[currency_beautify:");
    const endIndex = value.indexOf("]", startIndex);
    if (startIndex !== -1 && endIndex !== -1) {
      const currencySubstring = value.substring(startIndex, endIndex + 1);
      const currencyValue = await this.gameDatasService.getDVCurrency(currencySubstring);
      const htmlevalue = value.replace(currencySubstring, currencyValue);
      this.currencyValueHtml = htmlevalue;
      if (htmlevalue.includes("Credit")) this.isCredit = true;
    }
  }
  // Close slide up
  closeSlideUp() {
    this.bottomSheet.dismiss();
  }
}
